import { render, staticRenderFns } from "./MerchantModalSelector.vue?vue&type=template&id=52687a1e&"
import script from "./MerchantModalSelector.vue?vue&type=script&lang=js&"
export * from "./MerchantModalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports